<!-- @catalog A verdict at a glance: the medal, what it says, and who gave it. Pair with CAssessmentResult for the full block. -->
<template>
  <div v-if="label" class="tw-flex tw-items-center tw-gap-2">
    <q-icon :size="iconSize" :name="icon" :class="iconClass" />

    <span v-if="iconOnly === false" class="tw-text-sm tw-font-medium">
      {{ label }}
    </span>

    <span
      v-if="iconOnly === false && assessorLabel"
      class="tw-text-sm tw-text-gray-500"
    >
      {{ assessorLabel }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { assessmentGradeIcon, toDuotoneIcon } from "common/defaultIcons";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    // What the verdict says ("Voldaan", "7,5", "Wacht op beoordeling"). No
    // label means no badge.
    label?: string | null;
    // A verdict that has been given: the medal fills in.
    graded?: boolean;
    // Who gave it, worded by the caller ("door X"): this component is shared,
    // so it renders copy rather than writing it.
    assessorLabel?: string | null;
    iconSize?: string;
    iconOnly?: boolean;
  }>(),
  {
    label: null,
    graded: false,
    assessorLabel: null,
    iconSize: undefined,
    iconOnly: false,
  },
);

const icon = computed(() =>
  props.graded
    ? toDuotoneIcon(assessmentGradeIcon, "solid")
    : toDuotoneIcon(assessmentGradeIcon),
);

const iconClass = computed(() =>
  props.graded ? "duotone--graded" : "duotone--not-graded",
);
</script>
